import { takeEvery } from 'redux-saga'
import { put, select, all } from 'redux-saga/effects'
import { DESTROY_DOOR_CONTROLLER } from 'actions/entityActionTypes'
import { doorControllersSelector } from 'selectors'
import { deleteDoorControllerAction } from 'actions/entityActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

/** Remove door controller and any expansion boards */
export function* destroyDoorController(action) {
  try {
    const { doorControllers } = yield select(doorControllersSelector)
    const { id } = action

    const doorController = doorControllers[id]

    if (!doorController) return

    const expansionIds = doorController.expansionIds

    // remove expansion boards and their wires, if any
    for (let i = 0; i < expansionIds.length; i++) {
      yield put(deleteDoorControllerAction(expansionIds[i]))
    }

    // remove controller and wires
    yield put(deleteDoorControllerAction(id, true))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for destroy door controller action, then call function */
export function* watchDestroyDoorController() {
  yield* takeEvery(DESTROY_DOOR_CONTROLLER, destroyDoorController)
}



// WEBPACK FOOTER //
// ./src/sagas/destroyDoorControllerSaga.js